module.exports = __webpack_public_path__ + "img/logo_agp_pharma.daab045d.png";